import React, { useState, useEffect, useRef } from 'react';
import './mobile.scss';

function MobileCV() {
  const [typeText, setTypeText] = useState('');
  const [telRevealed, setTelRevealed] = useState(false);
  const strings = ['Rigoureux', 'Organisé', "Esprit d'équipe"];
  const ci = useRef(0);
  const si = useRef(0);

  useEffect(() => {
    let iv;

    function type() {
      setTypeText(strings[ci.current].substring(0, si.current + 1));
      si.current++;
      if (si.current === strings[ci.current].length) {
        clearInterval(iv);
        setTimeout(() => { iv = setInterval(del, 50); }, 1200);
      }
    }

    function del() {
      setTypeText(strings[ci.current].substring(0, si.current - 1));
      si.current--;
      if (si.current === 0) {
        clearInterval(iv);
        ci.current = (ci.current + 1) % strings.length;
        setTimeout(() => { iv = setInterval(type, 100); }, 250);
      }
    }

    iv = setInterval(type, 100);
    return () => clearInterval(iv);
  }, []);

  return (
    <div className="mobile-cv">

      {/* HERO */}
      <header className="hero" id="home">
        <svg className="hero-bolt" viewBox="0 0 80 140" width="110" fill="white" aria-hidden="true">
          <path d="M48 0L8 76h30L16 140l56-84H42L48 0z"/>
        </svg>

        <div className="hero-status">Disponible — Reconversion électricité</div>

        <h1>Philippe<br/><span>GENOT</span></h1>

        <p className="hero-sub">
          <span>{typeText}</span>
          <span className="cursor">|</span>
        </p>

        <div className="hero-btns">
          <a href="#contact" className="btn btn-fill">
            <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16" aria-hidden="true"><path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/><path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/></svg>
            Me contacter
          </a>
          <a href="/cv.pdf" target="_blank" rel="noreferrer" className="btn btn-ghost">
            <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16" aria-hidden="true"><path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd"/></svg>
            Télécharger le CV (PDF)
          </a>
        </div>
      </header>

      {/* À PROPOS */}
      <div className="pad">
        <div className="section-head" id="about">
          <svg className="bolt" viewBox="0 0 24 24" width="14" height="14" fill="#5b8aff" aria-hidden="true"><path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"/></svg>
          <h2>À propos</h2>
        </div>
        <div className="about-card">
          Né en Belgique en 1995, j'ai grandi en Amérique Latine avant de m'installer en France. Autonome, précis et consciencieux, <strong>je m'adapte facilement à de nouveaux environnements</strong>.<br/><br/>
          <strong>Passionné de nouvelles technologies</strong>, je me suis d'abord orienté vers le développement web (TP DWWM — RNCP niv. 5). Je cherche désormais à approfondir mes compétences techniques pour me <strong>spécialiser à terme dans la domotique et les bâtiments intelligents</strong>.
        </div>
      </div>

      {/* COMPÉTENCES */}
      <div className="pad">
        <div className="section-head" id="skills">
          <svg className="bolt" viewBox="0 0 24 24" width="14" height="14" fill="#5b8aff" aria-hidden="true"><path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"/></svg>
          <h2>Compétences</h2>
        </div>
        <div className="skill-cats">
          <div className="skill-cat">
            <div className="skill-cat-title">Électricité BT</div>
            <div className="skill-tags">
              <span className="stag">Câblage 230V monophasé</span>
              <span className="stag">Lecture de schémas</span>
              <span className="stag">Raccordements Wago / borniers</span>
              <span className="stag">Porte-fusibles & protections</span>
              <span className="stag">Mesure au multimètre</span>
              <span className="stag">Diagnostic de pannes</span>
              <span className="stag">Normes BT / TBTS</span>
            </div>
          </div>
          <div className="skill-cat">
            <div className="skill-cat-title">Électronique & mesure</div>
            <div className="skill-tags">
              <span className="stag">Câblage ESP32</span>
              <span className="stag">Soudures électroniques</span>
              <span className="stag">Convertisseurs AC/DC 230V→5V</span>
              <span className="stag">Mesure de tension & intensité</span>
              <span className="stag">Transformateur de courant (CT)</span>
              <span className="stag">Suivi de consommation</span>
            </div>
          </div>
          <div className="skill-cat">
            <div className="skill-cat-title">Domotique & IoT</div>
            <div className="skill-tags">
              <span className="stag">Programmation ESP32 / Arduino</span>
              <span className="stag">Interface web embarquée</span>
              <span className="stag">Communication Wi-Fi</span>
              <span className="stag">Télécommande d'équipements</span>
              <span className="stag">Supervision énergétique</span>
            </div>
          </div>
          <div className="skill-cat">
            <div className="skill-cat-title">Développement Web</div>
            <div className="skill-tags">
              <span className="stag">JavaScript / React / Vue.js</span>
              <span className="stag">PHP / WordPress</span>
              <span className="stag">HTML / CSS</span>
              <span className="stag">Node.js</span>
              <span className="stag">Docker</span>
            </div>
          </div>
        </div>
      </div>

      {/* EXPÉRIENCES */}
      <div className="pad">
        <div className="section-head" id="work">
          <svg className="bolt" viewBox="0 0 24 24" width="14" height="14" fill="#5b8aff" aria-hidden="true"><path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"/></svg>
          <h2>Expériences</h2>
        </div>
        <div className="timeline">
          <div className="tl-item">
            <div className="tl-date">Mars 2024 — Janv. 2026</div>
            <div className="tl-title">Assistant Administratif</div>
            <div className="tl-company">Montpellier Dépannage, Montpellier</div>
          </div>
          <div className="tl-item">
            <div className="tl-date">Juin — Août 2023</div>
            <div className="tl-title">Stage Développement Web</div>
            <div className="tl-company">ASAP Studio, Montpellier</div>
            <ul className="tl-bullets">
              <li>JavaScript Vanilla & PHP sur projets WordPress</li>
              <li>Composants Nuxt / Vue.js sur projet interne</li>
            </ul>
          </div>
          <div className="tl-item">
            <div className="tl-date">Sept. 2022 — Sept. 2023</div>
            <div className="tl-title">TP Développeur Web & Web Mobile — RNCP niv. 5</div>
            <div className="tl-company">Formation BeWeb / Fondespierre, Montpellier</div>
          </div>
          <div className="tl-item">
            <div className="tl-date">Oct. 2020 — Juin 2021</div>
            <div className="tl-title">Formateur Junior à distance</div>
            <div className="tl-company">ATE Formation, Montpellier</div>
            <ul className="tl-bullets">
              <li>FLE, Anglais, Espagnol, Pack Office / Microsoft 365</li>
            </ul>
          </div>
          <div className="tl-item">
            <div className="tl-date">Avr. 2019 — Sept. 2020</div>
            <div className="tl-title">Employé polyvalent de restauration</div>
            <div className="tl-company">La Cave du 164 · Hôtel Ibis Montpellier Sud</div>
            <ul className="tl-bullets">
              <li>Serveur, Barman, Sommelier, Cuisinier</li>
            </ul>
          </div>
        </div>
      </div>

      {/* FORMATION */}
      <div className="pad">
        <div className="section-head" id="formations">
          <svg className="bolt" viewBox="0 0 24 24" width="14" height="14" fill="#5b8aff" aria-hidden="true"><path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"/></svg>
          <h2>Formation</h2>
        </div>
        <div className="form-list">
          <div className="form-item">
            <div className="form-badge wip">⏳</div>
            <div>
              <div className="form-title">BTS Électrotechnique</div>
              <div className="form-sub wip">En cours de recherche — 2026–2028</div>
            </div>
          </div>
          <div className="form-item">
            <div className="form-badge done">✓</div>
            <div>
              <div className="form-title">TP Développeur Web & Web Mobile — RNCP niv. 5</div>
              <div className="form-sub">BeWeb / Fondespierre, Montpellier · 2023</div>
            </div>
          </div>
          <div className="form-item">
            <div className="form-badge done">✓</div>
            <div>
              <div className="form-title">Baccalauréat STMG</div>
              <div className="form-sub">Lycée Le Corbusier, Poissy · 2014</div>
            </div>
          </div>
        </div>
      </div>

      {/* CONTACT */}
      <div className="pad">
        <div className="section-head" id="contact">
          <svg className="bolt" viewBox="0 0 24 24" width="14" height="14" fill="#5b8aff" aria-hidden="true"><path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"/></svg>
          <h2>Contact</h2>
        </div>
        <div className="contact-list">
          <button className="contact-row" onClick={() => setTelRevealed(!telRevealed)} aria-label={telRevealed ? 'Masquer le numéro de téléphone' : 'Afficher le numéro de téléphone'}>
            <div className="c-icon">
              <svg viewBox="0 0 20 20" fill="#6b7a99" aria-hidden="true"><path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/></svg>
            </div>
            <div>
              <div className="c-label">Téléphone</div>
              <div className={`c-value${telRevealed ? ' revealed' : ''}`}>
                {telRevealed ? '06 68 02 86 97' : 'Afficher le numéro'}
              </div>
            </div>
            <svg className="c-arrow" viewBox="0 0 20 20" fill="currentColor" width="16" aria-hidden="true"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"/></svg>
          </button>
          <a href="mailto:philippe_genot@hotmail.fr?subject=J'ai vu ton CV en ligne" className="contact-row">
            <div className="c-icon">
              <svg viewBox="0 0 20 20" fill="#6b7a99" aria-hidden="true"><path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/><path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/></svg>
            </div>
            <div>
              <div className="c-label">Email</div>
              <div className="c-value">philippe_genot@hotmail.fr</div>
            </div>
            <svg className="c-arrow" viewBox="0 0 20 20" fill="currentColor" width="16" aria-hidden="true"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"/></svg>
          </a>
        </div>
      </div>

      <p className="mobile-footer">
        Prêt à mettre mon énergie à votre service.<br/>
        <strong>Philippe GENOT · Montpellier</strong>
      </p>

    </div>
  );
}

export default MobileCV;
